
interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomToFit: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
}

export function ZoomControls({ 
  onZoomIn, 
  onZoomOut, 
  onZoomToFit,
  canZoomIn, 
  canZoomOut
}: ZoomControlsProps) {
  return (
    <div 
      className="zoom-controls"
      style={{
        position: 'absolute',
        right: '20px',
        bottom: '70px',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
      }}
    >
      <button
        onClick={onZoomIn}
        disabled={!canZoomIn}
        style={{
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: !canZoomIn ? '#ccc' : '#fff',
          border: '2px solid #ddd',
          borderRadius: '4px 4px 0 0',
          cursor: !canZoomIn ? 'not-allowed' : 'pointer',
          fontSize: '18px',
          fontWeight: 'bold',
          color: !canZoomIn ? '#999' : '#333',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          outline: 'none',
          userSelect: 'none',
          transition: 'background-color 0.2s ease',
        }}
        onMouseEnter={(e) => {
          if (canZoomIn) {
            e.currentTarget.style.backgroundColor = '#f0f0f0';
          }
        }}
        onMouseLeave={(e) => {
          if (canZoomIn) {
            e.currentTarget.style.backgroundColor = '#fff';
          }
        }}
        title="Zoom in"
      >
        +
      </button>
      <button
        onClick={onZoomOut}
        disabled={!canZoomOut}
        style={{
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: !canZoomOut ? '#ccc' : '#fff',
          border: '2px solid #ddd',
          borderTop: '1px solid #ddd',
          borderRadius: '0',
          cursor: !canZoomOut ? 'not-allowed' : 'pointer',
          fontSize: '18px',
          fontWeight: 'bold',
          color: !canZoomOut ? '#999' : '#333',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          outline: 'none',
          userSelect: 'none',
          transition: 'background-color 0.2s ease',
        }}
        onMouseEnter={(e) => {
          if (canZoomOut) {
            e.currentTarget.style.backgroundColor = '#f0f0f0';
          }
        }}
        onMouseLeave={(e) => {
          if (canZoomOut) {
            e.currentTarget.style.backgroundColor = '#fff';
          }
        }}
        title="Zoom out"
      >
        −
      </button>
      <button
        onClick={onZoomToFit}
        style={{
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          border: '2px solid #ddd',
          borderTop: '1px solid #ddd',
          borderRadius: '0 0 4px 4px',
          cursor: 'pointer',
          color: '#333',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          outline: 'none',
          userSelect: 'none',
          transition: 'background-color 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f0f0f0';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#fff';
        }}
        title="Zoom to fit"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          {/* Four L-shaped corners forming a rectangle with gaps */}
          <path d="M3 7 V4 H6" />
          <path d="M14 4 H17 V7" />
          <path d="M17 13 V16 H14" />
          <path d="M6 16 H3 V13" />
        </svg>
      </button>
    </div>
  );
}